import { render, staticRenderFns } from "./BulkCalculationsHelp.vue?vue&type=template&id=10c5f586&scoped=true"
import script from "./BulkCalculationsHelp.vue?vue&type=script&lang=js"
export * from "./BulkCalculationsHelp.vue?vue&type=script&lang=js"
import style0 from "./BulkCalculationsHelp.vue?vue&type=style&index=0&id=10c5f586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5f586",
  null
  
)

export default component.exports